export const SELECTED_PARTY_CHANGED_EVENT = "selected-party-changed";
export const USER_LOGGED_OUT_EVENT = "user-logged-out";

export interface SelectedPartyChangedDetail {
	partyId: string | null;
}

export type SelectedPartyChangedEvent = CustomEvent<SelectedPartyChangedDetail>;

export interface UserLoggedOutDetail {
	initiatedBy: 'self' | 'sync';
}

export type UserLoggedOutEvent = CustomEvent<UserLoggedOutDetail>;
